import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Save, FileText, Loader2 } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminTextsSection = () => {
  const [texts, setTexts] = useState({
    heroTitle: '', heroSubtitle: '', heroDescription: '',
    aboutTitle: '', aboutDescription: '', bookingCta: '',
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const { getAuthHeaders } = useAuth();

  useEffect(() => { fetchTexts(); }, []);

  const fetchTexts = async () => {
    try {
      const response = await axios.get(`${API}/site-texts`);
      setTexts(response.data);
    } catch (error) {
      toast.error('Errore nel caricamento dei testi');
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/site-texts`, texts, { headers: getAuthHeaders() });
      toast.success('Testi salvati con successo!');
    } catch (error) {
      toast.error('Errore nel salvataggio');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="flex items-center justify-center h-48"><Loader2 className="h-8 w-8 animate-spin text-accent" /></div>;
  }

  return (
    <div className="space-y-6 max-w-4xl" data-testid="texts-section">
      <div>
        <h2 className="text-2xl sm:text-3xl font-bold mb-2">Testi del Sito</h2>
        <p className="text-muted-foreground text-sm">Modifica i testi visibili sul sito</p>
      </div>

      <Card className="card-elegant">
        <CardHeader><CardTitle className="text-lg flex items-center gap-2"><FileText className="h-5 w-5" /> Sezione Hero (Homepage)</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label>Titolo Principale</Label>
            <Input value={texts.heroTitle || ''} onChange={(e) => setTexts({ ...texts, heroTitle: e.target.value })} />
          </div>
          <div>
            <Label>Sottotitolo</Label>
            <Input value={texts.heroSubtitle || ''} onChange={(e) => setTexts({ ...texts, heroSubtitle: e.target.value })} />
          </div>
          <div>
            <Label>Descrizione</Label>
            <Textarea value={texts.heroDescription || ''} onChange={(e) => setTexts({ ...texts, heroDescription: e.target.value })} rows={3} />
          </div>
          <div>
            <Label>Testo Pulsante CTA</Label>
            <Input value={texts.bookingCta || ''} onChange={(e) => setTexts({ ...texts, bookingCta: e.target.value })} />
          </div>
        </CardContent>
      </Card>

      <Card className="card-elegant">
        <CardHeader><CardTitle className="text-lg">Sezione "Il Salone"</CardTitle></CardHeader>
        <CardContent className="space-y-4">
          <div>
            <Label>Titolo</Label>
            <Input value={texts.aboutTitle || ''} onChange={(e) => setTexts({ ...texts, aboutTitle: e.target.value })} />
          </div>
          <div>
            <Label>Descrizione</Label>
            <Textarea value={texts.aboutDescription || ''} onChange={(e) => setTexts({ ...texts, aboutDescription: e.target.value })} rows={4} />
          </div>
        </CardContent>
      </Card>

      <div className="flex justify-end">
        <Button onClick={handleSave} disabled={saving} className="bg-accent text-accent-foreground hover:bg-accent/90" data-testid="save-texts-btn">
          {saving ? <><Loader2 className="mr-2 h-4 w-4 animate-spin" /> Salvataggio...</> : <><Save className="mr-2 h-4 w-4" /> Salva Testi</>}
        </Button>
      </div>
    </div>
  );
};

export default AdminTextsSection;
